import { LoadingButton } from "@mui/lab";
import { Box, Button, InputAdornment, Link, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import Password from "src/components/Password";
import ChoosePlan from "src/components/choose-plan";
import {
  FormProvider,
  RHFCheckbox,
  RHFTextField,
} from "src/components/hook-form";
import Translate from "src/components/translate";
import GoogleOAuthButton from "src/pages/auth/components/google-login";
import { PATH_AUTH } from "src/routes/paths";
import AuthHelper from "./components/authHelper";
import EnterOtp from "./components/enter-otp";
import ErrorBanner from "./components/error-banner";
import useLogin from "./hooks/use-login";
import Iconify from "src/components/Iconify";
import { GOTO_HOME } from "src/config";

const LoginForm = () => {
  const { onSubmit, methods } = useLogin();

  const {
    watch,
    formState: { isSubmitting },
  } = methods;

  const data = watch();

  return (
    <>
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <Stack spacing={2} mb={2}>
          <AuthHelper />
          <ErrorBanner />
        </Stack>

        <Box>
          <Stack spacing={2.5}>
            <RHFTextField
              name="email"
              label="register.email_address"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Iconify
                      icon="ic:outline-email"
                      sx={{
                        color: "text.disabled",
                        width: 20,
                        height: 20,
                      }}
                    />
                  </InputAdornment>
                ),
              }}
            />
            <Password name="password" label="register.password" />
            <ChoosePlan />
          </Stack>

          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ my: 2.5 }}
          >
            <RHFCheckbox name="remember" label="register.remember_me" />
            <Link
              component={RouterLink}
              variant="subtitle2"
              sx={{
                color: "primary.main",
                fontWeight: 600,
                fontSize: "13px",
                textDecoration: "none",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
              to={PATH_AUTH.resetPassword}
            >
              <Translate>register.forgot_password</Translate>
            </Link>
          </Stack>

          <LoadingButton
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            loading={isSubmitting}
            name="login"
            sx={{
              py: 1.4,
              borderRadius: "12px",
              fontWeight: 700,
              fontSize: "15px",
              boxShadow: "0 8px 20px 0 rgba(12, 88, 64, 0.25)",
            }}
          >
            <Translate>register.sign_in</Translate>
          </LoadingButton>

          {/* Account Creation Footer Link */}
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={0.75}
            sx={{ mt: 3 }}
          >
            <Typography variant="body2" color="text.secondary">
              <Translate>register.dont_have_account</Translate>
            </Typography>
            <Link
              variant="subtitle2"
              component={RouterLink}
              to={PATH_AUTH.register}
              sx={{
                color: "primary.main",
                fontWeight: 700,
                textDecoration: "none",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
            >
              <Translate>register.create_account</Translate>
            </Link>
          </Stack>
        </Box>
      </FormProvider>

      <EnterOtp data={data} />
    </>
  );
};

export default LoginForm;
